<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast">
      <div class="toast-title">{{ toast.title }}</div>
      @if (toast.description) {
        <div class="toast-desc">{{ toast.description }}</div>
      }
    </div>
  }
</div>
